
export function TransactionRow({ transaction }) {
  const isMobile = window.screen.width < 500

  const date = new Date(transaction.created_at)
  const isValidDate = !isNaN(date.getTime())

  const formatter = new Intl.DateTimeFormat("ru", {
    weekday: "short",
    day: "numeric",
    month: "short",
    hour: "numeric",
    minute: "numeric",
  })

  const formattedDate = isValidDate
    ? formatter.format(date)
    : "Некорректная дата"

  const isWithdrawal = transaction.type === "withdrawal"
  const formattedAmount = isWithdrawal
    ? `-${transaction.amount}`
    : `+${transaction.amount}`

  return (
    <>
      <p>{transaction.id}</p>
      <p>{formattedDate}</p>
      <p>{transaction?.client?.name || "----"}</p>
      <p>{transaction.description}</p>
      <p
        className={` text-left font-semibold ${isWithdrawal ? "text-[#E92E51]" : "text-[#005018]"}`}
      >
        {formattedAmount}
      </p>
    </>
  )
}
